import React from 'react';
import { useTheme } from 'styled-components';

import { VirtualTourComposerProps } from 'Common/util/cmsComposer/VirtualTour';

import Main from 'Elements/Main';
import Section from 'Elements/Section';
import { H1, H2 } from 'Elements/Typography';

import Grid, { Col } from 'Components/Grid';
import Breadcrumbs, { BreadcrumbsProps } from 'Components/Breadcrumbs';
import { ListingCardProps } from 'Components/Card/Listing';

import { VirtualTourBlockRenderer } from 'Templates/VirtualTour';

import { Wave } from './VirtualTour.styled';

export interface Props {
    breadcrumbs: BreadcrumbsProps;
    heroBanner: {
        heading: string;
        subHeading: string;
    };
    content: VirtualTourComposerProps[];
    promoCard?: ListingCardProps;
}

const VirtualTour: React.FC<Props> = props => {
    const { breadcrumbs, heroBanner, content, promoCard } = props;

    const { colors } = useTheme();

    return (
        <Main>
            <Breadcrumbs {...breadcrumbs} />
            <div style={{ position: 'relative', overflow: 'hidden' }}>
                <Wave />
                <Section
                    background
                    id="hero"
                    backgroundColor={colors.secondary.tints[8].hex}
                    paddingTop={2.5}
                    overflow="hidden"
                >
                    <Grid>
                        <Col textAlign="center">
                            <H1 color={colors.accents[1].hex} spacing={{ base: { margin: 0 } }}>
                                {heroBanner.heading}
                            </H1>
                            <H2
                                color={colors.secondary.tints[1].hex}
                                weight={300}
                                spacing={{
                                    base: { margin: '0.5rem 0 0' },
                                    large: { margin: '1rem 0 0' }
                                }}
                            >
                                {heroBanner.subHeading}
                            </H2>
                        </Col>
                    </Grid>
                </Section>
                <Section
                    id="virtual-tours"
                    background
                    backgroundColor={colors.secondary.tints[8].hex}
                >
                    {VirtualTourBlockRenderer(content, promoCard)}
                </Section>
            </div>
        </Main>
    );
};

export default VirtualTour;
